export default __webpack_public_path__ + "static/media/tandem-email-logo.813d61ac.png";